import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const Wrapper = styled.div`
  border-radius: ${BorderRadius.R16};
  overflow: hidden;
`

export const BadgesContainer = styled.div`
  padding: ${Spacing.S16};
  background-color: ${Color.Grey50};
`
